import React from 'react';

const Extension = () => (
  <svg
    width='29'
    height='26'
    viewBox='0 0 29 26'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M26.1089 5.89185H5.26172C5.02965 5.89185 4.80709 5.79966 4.643 5.63556C4.47891 5.47147 4.38672 5.24891 4.38672 5.01685C4.38672 4.78478 4.47891 4.56222 4.643 4.39813C4.80709 4.23403 5.02965 4.14185 5.26172 4.14185H26.2617C26.4938 4.14185 26.7163 4.04966 26.8804 3.88556C27.0445 3.72147 27.1367 3.49891 27.1367 3.26685C27.1367 2.57065 26.8602 1.90297 26.3679 1.41069C25.8756 0.918408 25.2079 0.641846 24.5117 0.641846H4.38672C3.45846 0.641846 2.56822 1.01059 1.91184 1.66697C1.25547 2.32335 0.886719 3.21359 0.886719 4.14185V21.6418C0.886719 22.5701 1.25547 23.4603 1.91184 24.1167C2.56822 24.7731 3.45846 25.1418 4.38672 25.1418H26.1089C26.825 25.1607 27.5193 24.895 28.0399 24.4031C28.5606 23.9111 28.8651 23.2328 28.8867 22.5168V8.51685C28.8651 7.80086 28.5606 7.12262 28.0399 6.63064C27.5193 6.13865 26.825 5.873 26.1089 5.89185ZM11.2467 18.0006L11.2549 17.9901L8.76172 20.4775V10.5608L13.7189 15.5238L18.6784 10.5608V20.4775L16.1992 18.0006L13.7201 20.4775L11.2467 18.0006ZM26.3863 15.9583C26.3863 16.8049 25.7 17.4913 24.8533 17.4913C24.0067 17.4913 23.3203 16.8049 23.3203 15.9583C23.3203 15.1116 24.0067 14.4253 24.8533 14.4253C25.7 14.4253 26.3863 15.1116 26.3863 15.9583Z'
      fill='white'
    />
  </svg>
);

export default Extension;
